// extracted by mini-css-extract-plugin
export default {"container":"NotificationsDesktop_container__Fb1nP","mask":"NotificationsDesktop_mask__IcOaX"};